import { OrderDoc } from '@gooduncles/gu-app-schema';
import { keyBy, mapValues } from 'lodash-es';
import { FC, useCallback } from 'react';

import useIssueCasesForOrder from 'src/hooks/subscription/useIssueCasesForOrder';
import useStoreById from 'src/hooks/swr/useStoreById';
import { useScrollToElement } from 'src/hooks/useScrollToElement';

import AddressPopover from 'src/atomic-components/molecules/AddressPopover/AddressPopover';
import IssueColumnHeader from 'src/atomic-components/organisms/IssuePanel/IssueColumnHeader';
import IssueEditSection from 'src/atomic-components/organisms/IssuePanel/IssueEditSection';
import IssueTargetSection from 'src/atomic-components/organisms/IssuePanel/IssueTargetSection';

import columnStyles from 'src/atomic-components/atoms/Column/Column.module.scss';
import classes from './IssueRegister.module.scss';

interface OrderTabContentProps {
  order: OrderDoc;
}

const OrderTabContent: FC<OrderTabContentProps> = ({ order }) => {
  const { store } = useStoreById(order.storeId);
  const issueCases = useIssueCasesForOrder(order._id);

  const parentProducts = mapValues(keyBy(order.products, 'productId'), 'volume');

  const { containerRef: caseColumnRef, scrollTo: scrollToIssueCase } = useScrollToElement();

  const scrollToCaseCard = useCallback(
    (caseId: string) => {
      scrollToIssueCase(`case-card-${caseId}`);
    },
    [scrollToIssueCase]
  );

  return (
    <div className={classes.tabContent}>
      <div className={columnStyles.column}>
        <IssueColumnHeader>
          파트너: {order.deliveryPartnerName}
          {order.deliverySpotId && <AddressPopover deliverySpotId={order.deliverySpotId} storeId={order.storeId} />}
        </IssueColumnHeader>
        <IssueTargetSection order={order} store={store} issueCases={issueCases} onIssueCaseClick={scrollToCaseCard} />
      </div>
      <IssueEditSection issueCases={issueCases} parentProducts={parentProducts} caseColumnRef={caseColumnRef} />
    </div>
  );
};

export default OrderTabContent;
